/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

interface ADProps {
  acceptedFile: boolean;
  getRootProps: any;
  children: any;
  size?: number;
}
export const AvatarDropArea = ({ acceptedFile, getRootProps, children, size }: ADProps) => {
  return (
    <DropArea hasAcceptedFile={acceptedFile} {...getRootProps()} size={size}>
      {children}
    </DropArea>
  );
};

interface AvatarWrapperProps {
  brightnessCanChange?: boolean;
}

export const AvatarWrapper = styled.div<AvatarWrapperProps>`
  filter: ${({ brightnessCanChange }) => (brightnessCanChange ? "brightness(0.8)" : "")};
  height: 100%;
  width: 100%;
  border-radius: 50%;
  :hover {
    filter: ${({ brightnessCanChange }) => (brightnessCanChange ? "brightness(0.85)" : "")};
  }
`;

export const DropZoneIconWrapper = styled.div`
  position: absolute;
  color: black;
`;

interface Props {
  hasAcceptedFile?: File;
  size?: number;
}
const DropArea = styled.div<Props>`
  width: ${(props) => (props.size ? `${props.size}px` : "75px")};
  height: ${(props) => (props.size ? `${props.size}px` : "75px")};
  background: ${(props) => (props.hasAcceptedFile ? "#f6f6f6" : "#fbfbfb")};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
`;
